import { render, staticRenderFns } from "./HeaderVue.vue?vue&type=template&id=5a0bf512&scoped=true"
import script from "./HeaderVue.vue?vue&type=script&lang=js"
export * from "./HeaderVue.vue?vue&type=script&lang=js"
import style0 from "./HeaderVue.vue?vue&type=style&index=0&id=5a0bf512&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0bf512",
  null
  
)

export default component.exports